import { render } from "./SlideOver.vue?vue&type=template&id=51e45b9a"
import script from "./SlideOver.vue?vue&type=script&lang=js"
export * from "./SlideOver.vue?vue&type=script&lang=js"
script.render = render

export default script